// Copyright (c) StrangeBee 2023

import client from '@Client';
import { useCallback } from 'react';
import { QueryKey, UseQueryResult } from 'react-query';
import { useGenericQuery } from './genericQueries';
import { UISettingsParams } from 'thehive-sdk';

export const useGetSettings = (): UseQueryResult<UISettingsParams, QueryKey> => {
    const fetchCallback = useCallback(() => client.UISettingsController.list<UISettingsParams>(), []);

    return useGenericQuery({ fetchCallback, key: ['UISettingsController.list'], retry: false, manual: true });
};
